import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import css from './index.module.scss';

const B: React.FC = () => {
    const { t } = useLang('d3u');

    const renderBtn: JSX.Element = (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="36" width="36" height="36" rx="18" transform="rotate(90 36 0)" fill="black" fillOpacity="0.2" />
            <path
                d="M12.7399 14.7359C12.2959 14.2886 11.5762 14.2886 11.1322 14.7359C10.6882 15.1832 10.6882 15.9085 11.1322 16.3558L17.1953 22.4648C17.6354 22.9083 18.3476 22.9128 18.7931 22.4748L24.8563 16.5144C25.3057 16.0726 25.3146 15.3474 24.8761 14.8946C24.4376 14.4418 23.7179 14.4329 23.2685 14.8747L18.009 20.0449L12.7399 14.7359Z"
                fill="white"
                fillOpacity="0.8"
            />
        </svg>
    );

    return (
        <section
            className={`${css.section} D3U-B GtmModuleData-section`}
            id="D3U-B"
            data-section-id={'D3U-B'}
            data-section-id2={t.rich('B_item5_name', {
                b: (tx: string) => tx,
            })}
        >
            <div className="info">
                <div className="title">{t('B_title')}</div>
            </div>
            <div className="wrapper wrapper-pc">
                <div className="l">
                    <EcoLink className="t box" href={'#D3U-L'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694032295/2_1.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item1_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item1_text')}</p>
                        </div>
                    </EcoLink>
                    <EcoLink className="m box" href={'#D3U-K'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694007898/2_2.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item2_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item2_text')}</p>
                        </div>
                    </EcoLink>
                    <EcoLink className="b box" href={'#D3U-N'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694005580/2_3.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item3_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item3_text')}</p>
                        </div>
                    </EcoLink>
                </div>
                <div className="c">
                    <EcoLink className="t box" href={'#D3U-E'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694008251/2_4.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item4_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item4_text')}</p>
                        </div>
                    </EcoLink>
                    <EcoLink className="m box" href={'#D3U-C'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694006064/2_5.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item5_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item5_text')}</p>
                        </div>
                    </EcoLink>
                    <EcoLink className="b box" href={'#D3U-D'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694005673/2_6.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item6_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item6_text')}</p>
                        </div>
                    </EcoLink>
                </div>
                <div className="r">
                    <EcoLink className="t box" href={'#D3U-M'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694007277/2_7.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item7_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item7_text')}</p>
                        </div>
                    </EcoLink>
                    <EcoLink className="m box" href={'#D3U-G'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694006583/2_8.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item8_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item8_text')}</p>
                        </div>
                    </EcoLink>
                    <EcoLink className="b box" href={'#D3U-I'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1761529912107/2_9.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item9_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                        </div>
                    </EcoLink>
                </div>
            </div>
            <div className="wrapper wrapper-h5">
                <EcoLink className="r1 box" href={'#D3U-C'}>
                    <div className="img">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694570955/2_1_M.jpg" />
                        {renderBtn}
                    </div>
                    <div className="msg">
                        <p className="name">
                            {t.rich('B_item5_name', {
                                b: (tx: string) => <span className="bd">{tx}</span>,
                            })}
                        </p>
                        <p className="text">{t('B_item5_text')}</p>
                    </div>
                </EcoLink>
                <div className="r2">
                    <EcoLink className="l box" href={'#D3U-K'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694572615/2_2_M.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item2_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item2_text')}</p>
                        </div>
                    </EcoLink>
                    <EcoLink className="r box" href={'#D3U-G'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694573326/2_3_M.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item8_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item8_text')}</p>
                        </div>
                    </EcoLink>
                </div>
                <EcoLink className="r3 box" href={'#D3U-E'}>
                    <div className="img">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694573155/2_4_M.jpg" />
                        {renderBtn}
                    </div>
                    <div className="msg">
                        <p className="name">
                            {t.rich('B_item4_name', {
                                b: (tx: string) => <span className="bd">{tx}</span>,
                            })}
                        </p>
                        <p className="text">{t('B_item4_text')}</p>
                    </div>
                </EcoLink>
                <div className="r4">
                    <EcoLink className="l box" href={'#D3U-L'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694571289/2_5_M.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item1_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item1_text')}</p>
                        </div>
                    </EcoLink>
                    <EcoLink className="r box" href={'#D3U-M'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694572833/2_6_M.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item7_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item7_text')}</p>
                        </div>
                    </EcoLink>
                </div>
                <div className="r5">
                    <EcoLink className="l box" href={'#D3U-N'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694572493/2_7_M.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item3_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                            <p className="text">{t('B_item3_text')}</p>
                        </div>
                    </EcoLink>
                    <EcoLink className="r box" href={'#D3U-I'}>
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1761529911924/2_8_M.jpg" />
                            {renderBtn}
                        </div>
                        <div className="msg">
                            <p className="name">
                                {t.rich('B_item9_name', {
                                    b: (tx: string) => <span className="bd">{tx}</span>,
                                })}
                            </p>
                        </div>
                    </EcoLink>
                </div>
                <EcoLink className="r6 box" href={'#D3U-D'}>
                    <div className="img">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760694571909/2_9_M.jpg" />
                        {renderBtn}
                    </div>
                    <div className="msg">
                        <p className="name">
                            {t.rich('B_item6_name', {
                                b: (tx: string) => <span className="bd">{tx}</span>,
                            })}
                        </p>
                        <p className="text">{t('B_item6_text')}</p>
                    </div>
                </EcoLink>
            </div>
            <p className="tip">{t('B_tip')}</p>
        </section>
    );
};

export default B;
